export class InitializeUserDataState {
  static readonly type = '[UserData] InitializeUserDataState';
}
